module.exports = __webpack_public_path__ + "img/nl-matching-mobile.568de336.png";